<template>
  <main class="view-failed-payment d-flex flex-md-row flex-xxs-column-reverse col-lg-10 col-md-12 col-xxs-10 mx-auto px-lg-5 px-xxs-0 py-sm-5 py-xxs-0">
    <div class="px-lg-0 px-md-4 px-xxs-0" />
    <section class="d-flex flex-column justify-content-center mt-5 py-3 px-lg-5 px-xxs-0">
      <h1 class="text-danger mb-5 display-3">
        {{ $t('UserProfile.Subscription.FailedPayment.Title') }}
      </h1>
      <p class="lead text-white line-height-2" v-html="$t('UserProfile.Subscription.FailedPayment.Description')" />
      <div class="d-flex flex-sm-row flex-xxs-column align-items-center justify-content-end mt-5">
        <span class="d-md-flex d-xxs-none text-light">
          {{ $t('UserProfile.Subscription.FailedPayment.AnyQuestion') }}
        </span>
        <b-button
          :to="{name:'contact-us'}"
          variant="success"
          size="lg"
          class="px-5 mx-sm-3 mx-xxs-0"
        >
          {{ $t('UserProfile.Subscription.FailedPayment.ContactUs') }}
        </b-button>
      </div>
    </section>
    <img width="512" class="mt-5 col-xxl-4 col-xs-5 col-xxs-8 align-self-center" src="@/assets/icons/disaster-monster.svg">
  </main>
</template>

<script>
import RootAccessor from '@/mixins/root-accessor'
export default {
  name: 'FailedPayment',
  mixins: [
    RootAccessor
  ],
  mounted () {
    this.addDataAttribute('data-theme', 'dark')
  },
  destroyed () {
    this.clearBodyAttribute('data-theme')
  }
}
</script>
